import React from 'react'
import { XAxis } from 'recharts'
import moment from 'moment'
import { useMediaQuery, useTheme } from '@mui/material'

interface Props {
  isModal: boolean
  lastItemIndex: number
}

const XAxisPowerPriceChart: React.FC<Props> = ({ isModal, lastItemIndex }) => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <XAxis
      dataKey="from"
      interval={0}
      tickLine={false}
      hide={!isModal}
      tickFormatter={(value, index) => {
        const time = moment(value)
        return formatXAxisTicks(!downSm, lastItemIndex)(time.format('HH:mm'), index)
      }}
      style={{
        fontSize: 11,
      }}
    />
  )
}

export default XAxisPowerPriceChart

/** helper functions */
const formatXAxisTicks = (upSm: boolean, lastItemIndex: number) => (value: string, index: number) => {
  const [hour, minutes] = value.split(':')
  if (upSm) {
    return minutes === '00' ? hour : ''
  } else {
    if (minutes !== '00') return ''
    if (minutes === '00' && (index === 0 || index === lastItemIndex)) return ''
    if (Number(hour) % 3 === 0) {
      return hour
    }
    return ''
  }
}
